class InstalatorConfig {

  static initRoute ($stateProvider, $urlRouterProvider) {
    'ngInject';
    $stateProvider.state('public.users.instalator', {
      url: "/instalator",
      abstract: true,
      template: require("./instalator.html")
    }).state('protected.users.instalator', {
      url: "/instalator",
      abstract: true,
      template: require("./instalator.html")
    }).state('public.users.instalator.instalator-registration', {
      url: "/instalator-registration",
      template: require("./instalator-registration.html"),
      controller: "InstalatorRegistrationUsersController as instalatorregistration"
    }).state('public.users.instalator.instalator-registration-confirm', {
      url: "/instalator-registration-confirm",
      template: require("./instalator-registration-confirm.html"),
      controller: "InstalatorRegistrationConfirmUsersController as instalatorregistrationconfirm"
    }).state('public.users.instalator.instalator-login', {
      url: "/instalator-login",
      params: {
        licenseId: null
      },
      template: require("./instalator-login.html"),
      controller: "InstalatorLoginUsersController as instalatorlogin"
    }).state('public.users.instalator.instalator-confirmed', {
      url: "/instalator-confirmed",
      template: require("./instalator-confirmed.html"),
      controller: "InstalatorConfirmedUsersController as instalatorconfirmed"
    }).state('protected.users.instalator.shared-resources', {
      url: "/shared-resources",
      template: require("./instalator-shared-resources.html"),
      controller: "InstalatorSharedResourceUsersController as instalatorsharedresources"
    }).state('public.users.instalator.activation', {
      url: "/instalator-activation?idNumber&token&lang",
      template: require("./instalator-activation.html"),
      controller: "InstalatorActivationUsersController as instalatoractivation"
    });
  }
}

export default InstalatorConfig.initRoute;



// WEBPACK FOOTER //
// ./src/users/instalator/instalator.config.js